(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Mark sold-out cards — runs on load and after AJAX filter updates
  function markSoldOut() {
    document.querySelectorAll('.product-badges__badge:not(.badge--agotado)').forEach(badge => {
      const text = badge.textContent.trim().toLowerCase();
      if (text === 'agotado' || text === 'sold out') {
        badge.classList.add('badge--agotado');
        const card = badge.closest('product-card');
        if (card) card.classList.add('product-card--sold-out');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    markSoldOut();
    const grid = document.querySelector('.product-grid-container');
    if (grid) {
      new MutationObserver(markSoldOut).observe(grid, { childList: true, subtree: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  function markSoldOutSearch() {
    document.querySelectorAll('.product-badges__badge:not(.badge--agotado)').forEach(badge => {
      const text = badge.textContent.trim().toLowerCase();
      if (text === 'agotado' || text === 'sold out') {
        badge.classList.add('badge--agotado');
        const card = badge.closest('product-card');
        if (card) card.classList.add('product-card--sold-out');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    markSoldOutSearch();
    const grid = document.querySelector('.product-grid-container');
    if (grid) {
      new MutationObserver(markSoldOutSearch).observe(grid, { childList: true, subtree: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
